import {ref} from "@vue/composition-api";
import * as L1 from "leaflet.markercluster";
import L from 'leaflet'
import mapCommon from "@/views/modules/maps/functions/mapCommon";

import moment from 'moment'

export default function useLiveMapMarkers() {

    // moment.locale('ar')

    const markers = ref([])
    const markersCluster = new L1.MarkerClusterGroup()
    const markersGroupLayer = L.layerGroup();

    const allMarkersVisibility = ref(true)
    const markerLabels = ref(true)

    const { createMarker, createIcon, myPopup } = mapCommon()

    const init_marker = (device) => {
        const ico = createIcon(device, markerLabels.value)
        const marker = createMarker(device, myPopup, ico)
        marker.device = device
        markersCluster.addLayer(marker)
        markersGroupLayer.addLayer(marker)
        markers.value[device.id] = marker
    }


    return {
        init_marker,
        markers,
        markerLabels,
        markersCluster,markersGroupLayer,
        allMarkersVisibility
    }
}
